<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import VueDropify from "vue-dropify";
import draggable from "vuedraggable";
import VLazyImage from "v-lazy-image/v2";

// Custom Components
import PageHeader from "@/components/page-header";
import RoomType from "@/components/inventory/roomType.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Room Type Component
export default {
  page: {
    title: "Room Type",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    RoomType,
    PageHeader,
    VueDropify,
    draggable,
    VLazyImage,
  },
  data() {
    return {
      title: "Room Type",
      isLoading: true,
      editable: true,
      isDragging: false,
      table: {
        tableData: [],
      },
      imagePreView: [],
      imagePreViewRoomType: null,
      openImagePreviewModal: false,
      openNewRoomTypeForm: false,
      selectedRoomType: null,
      room_type_images: "",
      submitted: null,
      isEdit: false,
      is_btn_loading: false,
      nameList: [],
      shortCodeNameList: [],
    };
  },
  validations: {
    room_type_images: {
      required,
    },
  },
  computed: {
    ...authComputed,
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
    rows() {
      return this.table.tableData.length;
    },
    roomTypeProps() {
      return {
        selectedRoomType: this.selectedRoomType,
        isEdit: this.isEdit,
      };
    },
  },
  mounted() {
    // this.getRoomTypes();
  },
  methods: {
    // Method is use for get all room type
    async getRoomTypes() {
      await UserService.getRoomTypeList()
        .then((room_types) => {
          this.table.tableData = room_types;
          this.isLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for open new room type form
    newRoomTypeForm() {
      if (this.openNewRoomTypeForm == true) {
        this.selectedRoomType = null;
        this.isEdit = false;
      }
      this.openNewRoomTypeForm = !this.openNewRoomTypeForm;
    },
    // Method is use for add and update room type
    roomTypeAddedUpdated(roomType) {
      if (this.isEdit == true) {
        this.table.tableData = this.table.tableData.map((item) => {
          if (item.id === roomType.id) {
            item = roomType;
          }
          return item;
        });
        Middleware.notification("Successfully updated !!", "success");
      } else {
        this.table.tableData.push(roomType);
        Middleware.notification("Successfully added !!", "success");
      }
      this.newRoomTypeForm();
    },
    // Method is use for save and add new
    roomTypeSaveAndAdd(roomType) {
      this.table.tableData.push(roomType);
      Middleware.notification("Successfully added !!", "success");
    },
    // Method is use for maintained edit room type data
    edit(data) {
      this.selectedRoomType = data;
      this.isEdit = true;
      this.newRoomTypeForm();
    },
    // Method is use for show image preview
    imagePreviewModal(row) {
      this.imagePreView = row.room_type_image;
      this.imagePreViewRoomType = row.id;
      this.openImagePreviewModal = !this.openImagePreviewModal;
    },
    //Method is use for change image as thumbnail image
    changeThumbnailImageStatus(image) {
      const imageData = new FormData();
      imageData.append("is_thumbnail", image.is_thumbnail);
      UserService.updateRoomTypeImage(
        image.room_type,
        image.id,
        imageData
      ).then(
        (response) => {
          this.imagePreView = this.imagePreView.map((image) => {
            if (image.id !== response.id) {
              image = { ...image, is_thumbnail: false };
            } else {
              image = { ...image, is_thumbnail: true };
            }
            return image;
          });
          Middleware.notification(
            "Successfully set as thumbnail image !!",
            "success"
          );
        },
        (error) => {
          errorHandler(error);
        }
      );
    },
    // Method is use for delete image
    deleteImage(image, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteRoomTypeImage(image.room_type, image.id).then(
            () => {
              this.imagePreView.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "warning");
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    // Method is use for add new image in room type
    submitImages() {
      this.submitted = true;
      this.is_btn_loading = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.is_btn_loading = false;
        return;
      } else {
        let roomTypeData = new FormData();
        roomTypeData.append("room_type", this.imagePreViewRoomType);
        Object.keys(this.room_type_images).map((image) => {
          roomTypeData.append("image", this.room_type_images[image]);
        });
        UserService.addRoomTypeImage(
          this.imagePreViewRoomType,
          roomTypeData
        ).then(
          (roomTypeImage) => {
            this.imagePreView.push(roomTypeImage);
            this.room_type_images = null;
            this.is_btn_loading = false;
            this.submitted = false;
          },
          (error) => {
            this.is_btn_loading = false;
            errorHandler(error);
          }
        );
      }
    },
    // Method is use for maintained change image event
    changeRoomTypeImage(event) {
      this.room_type_images = event == undefined ? "" : event;
    },
    // Method is use for change room image
    onChoose: function (evt) {
      const imageData = new FormData();
      imageData.append("priority_order", evt.moved.newIndex + 1);
      UserService.updateRoomTypeImage(
        evt.moved.element.room_type,
        evt.moved.element.id,
        imageData
      )
        .then(() => {
          Middleware.notification("Image positions changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="newRoomTypeForm"
      text="Add New Room Type"
      :isButton="true"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <div class="table-responsive mb-0" v-dragscroll>
                  <!-- Table -->
                  <table
                    class="table table-hover mb-0 common-table"
                    ref="my-table"
                    v-infinite-scroll="getRoomTypes"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>Name</th>
                        <th>Short Code Name</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="isLoading">
                      <tr v-for="(item, index) in 20" :key="index">
                        <td class="placeholder-glow" v-for="no in 4" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="(data, index) in table.tableData" :key="index">
                        <td @click="edit(data)">
                          <div class="d-flex align-items-center">
                            <template v-for="image in data.room_type_image">
                              <v-lazy-image
                                v-if="image.is_thumbnail"
                                :key="image.id"
                                :src="
                                  image.image.replace('upload', 'thumbs200')
                                "
                                alt=""
                                class="rounded-circle picture-img"
                              />
                            </template>
                            <img
                              v-if="data.room_type_image.length == 0"
                              key="image"
                              src="@/assets/images/placeholder.png"
                              alt=""
                              class="rounded-circle picture-img"
                            />

                            <span class="text-truncate ms-2 d-block w-75">{{
                              data.name
                            }}</span>
                          </div>
                        </td>
                        <td @click="edit(data)">
                          {{ data.short_name }}
                        </td>
                        <td>
                          <span
                            class="badge align-items-center py-1 px-2 card-badge"
                            :class="[
                              data.is_active
                                ? 'badge-soft-success'
                                : 'badge-soft-danger',
                            ]"
                          >
                            {{ data.is_active ? "Active" : "Disabled" }}
                          </span>
                        </td>
                        <td>
                          <div slot="actions" class="d-flex align-items-center">
                            <i
                              class="fas fa-pencil-alt text-success me-2"
                              v-b-popover.hover="'Edit room type'"
                              @click="edit(data)"
                            ></i>

                            <i
                              v-b-popover.hover="'Preview images'"
                              class="fas fa-camera text-primary"
                              v-b-modal.image-preview-modal
                              @click="imagePreviewModal(data)"
                            ></i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The model is for view image of guest experience -->
    <b-modal
      v-if="openImagePreviewModal"
      id="image-preview-modal"
      title="Room Type All Images Preview"
      centered
      hide-footer
      @hidden="
        openImagePreviewModal = false;
        submitted = false;
      "
    >
      <div class="container">
        <div class="row">
          <div class="col-12">
            <VueDropify
              @upload="changeRoomTypeImage($event)"
              :src="room_type_images ? room_type_images : ''"
              message="Drop image here or click to select"
              id="room_type_images"
              class="mb-3"
              :class="{
                'is-invalid': submitted && $v.room_type_images.$error,
              }"
            />
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.room_type_images.required"
                >Room type images is required.</span
              >
            </div>
          </div>
        </div>
        <div class="upload-img-scrollbar" style="upload-img-style">
          <draggable
            class="row"
            v-model="imagePreView"
            v-bind="dragOptions"
            @change="onChoose"
          >
            <div
              class="col-md-6"
              v-for="(image, index) in imagePreView"
              :key="index"
            >
              <div class="d-flex align-items-start mb-2">
                <div>
                  <img
                    class="rounded avatar-xl cursor-move w-100 object-fit"
                    alt="room_type_image"
                    :src="typeof image.image !== null || '' ? image.image : ''"
                    :id="image.id"
                    data-holder-rendered="true"
                  />
                </div>
                <div class="ms-2">
                  <div class="form-check">
                    <input
                      :disabled="imagePreView.length == 1 && image.is_thumbnail"
                      class="form-check-input"
                      type="checkbox"
                      :id="image.is_thumbnail"
                      v-model="image.is_thumbnail"
                      v-b-popover.hover="'Use as thumbnail image'"
                      @change="changeThumbnailImageStatus(image)"
                    />
                  </div>
                  <i
                    class="mdi mdi-trash-can fs-5 text-danger"
                    v-if="imagePreView.length !== 1"
                    slot="lable"
                    @click="deleteImage(image, index)"
                  ></i>
                </div>
              </div>
            </div>
          </draggable>
        </div>

        <div class="row">
          <div class="col-12">
            <b-button
              variant="outline-primary"
              class="float-end ms-2 mt-1"
              type="reset"
              @click="imagePreviewModal"
            >
              Cancel</b-button
            >
            <b-button
              variant="outline-primary"
              class="float-end mt-1"
              type="submit"
              @click="submitImages()"
              :class="{ disabled: is_btn_loading }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="is_btn_loading"
              ></i>
              Add New Image
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <Drawer
      @close="newRoomTypeForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openNewRoomTypeForm">
        <RoomType
          :currentProps="roomTypeProps"
          @submitted="roomTypeAddedUpdated"
          @cancelSubmit="newRoomTypeForm"
          @SaveAndAddNew="roomTypeSaveAndAdd"
        />
      </div>
    </Drawer>
  </div>
</template>
